import { render, staticRenderFns } from "./ProductTechnicalSheets.vue?vue&type=template&id=6ce1215d&scoped=true&"
import script from "./ProductTechnicalSheets.vue?vue&type=script&lang=js&"
export * from "./ProductTechnicalSheets.vue?vue&type=script&lang=js&"
import style0 from "./ProductTechnicalSheets.vue?vue&type=style&index=0&id=6ce1215d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce1215d",
  null
  
)

export default component.exports